import { getCustomScheduleDateColumns } from "@/pages/workflows/edit/pages/workflow-edit-pages.tsx";
import { useEmployeeSearchColumns } from "@/queries/employees/use-employees.query.ts";
import { useAppConfig } from "@/queries/settings/use-app.query.ts";
import { ApiAppConfigUIEmployeeProfileTable } from "@/types/config.types.ts";
import { ApiWorkflowTriggerScheduleEntityField } from "@/types/workflows/workflow.base-enum.types.ts";
import { SelectItem } from "@skailer-com/uikit";
import { useMemo } from "react";

export interface CustomScheduleDateFieldOption extends SelectItem {
  id: number;
  isHistorical: boolean;
}

export const useCustomScheduleDateFields = (
  field: ApiWorkflowTriggerScheduleEntityField,
  enabled: boolean = true
) => {
  const { data: columns, isLoading } = useEmployeeSearchColumns(enabled);
  const { data: appConfig } = useAppConfig();

  const options = useMemo<CustomScheduleDateFieldOption[]>(() => {
    const tableById = new Map<number, ApiAppConfigUIEmployeeProfileTable>();
    appConfig?.ui.employee_profile.tabs.forEach(({ items }) =>
      items.forEach(({ table }) => {
        if (table) tableById.set(table.id, table);
      })
    );

    return getCustomScheduleDateColumns(field, columns).map((column) => {
      const table = column.table_id !== null ? tableById.get(column.table_id) : undefined;
      return {
        id: column.field_id,
        title: column.title,
        group: table?.title,
        isHistorical: table?.is_historical ?? false,
      };
    });
  }, [appConfig, columns, field]);

  return { options, isLoading };
};
